<div class="services-box">
	<ng-container *ngIf="!isLoading; else loading">
		<div class="services-title-bar" translate>{{ headerLabel }}</div>
		<button (click)="evtRequestNewOffer()" type="button" mat-button color="primary" class="services-label">
			<span class="widget-resize-double-line" translate>{{ btnLabel }}</span>
			<mat-icon iconPositionEnd class="service-icon copo-small-icon-button" svgIcon="plus_icon"></mat-icon>
		</button>
		<div class="service-box-footer">
			<ng-container *ngIf="draftCount > 0">
				<button type="button" mat-button color="primary" [routerLink]="['/offer/draft']">
					<span class="widget-draft-number">{{ draftCount | copoNumber: 'number' }}</span>
					<span class="widget-draft" translate>drafts.saved</span>
					<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
				</button>
			</ng-container>
		</div>
	</ng-container>
	<ng-template #loading>
		<copo-loading-spinner></copo-loading-spinner>
	</ng-template>
</div>